<% if (compactDisplay) { %>
  <% var group = addressGroups[0] %>
  <% var address = addressGroups[0].address %>
  <label class="field-label" data-behaviour="date-select" data-department-id="<%= address.departmentId %>" data-analytics-element="booking-reselect-more-dates" data-analytics-interaction="click">
    <span class="selected-date"><%= selectedDate && Sparkle.Utilities.appointmentDate(moment.parseZone(selectedDate), AppointmentBooking.config.slot_show_year, "dddd, MMMM D", "dddd, MMMM D, YYYY") %></span>
    <a href class="date-select-link"><%= I18n.suggestion_selector.see_more_dates %></a>
  </label>
  <div class="slot-stacks">
    <% group.slotStacks.forEach(function(stack){ %>
      <span class="slot-stack<% if (stack.containsSelectedSlot) { %> slot-stack--selected<% } %><% if (stack.slots.length > 1) { %> slot-stack--many-slots<% } else { %> slot-stack--one-slot<% } %><% if (stack.desiredTimeSlot) { %> --desired-time-slot<% } %>" data-slot-start-time="<%= stack.startTime %>">
        <span class="time"><%= moment.parseZone(stack.startTime).format(I18n.moment_time_format) %></span>
        <span class="text" title="<%= stack.text %>"><%= stack.text %></span>
        <% if (stack.desiredTimeSlot) { %>
          <span class="button-caption"><%= I18n.suggestion_selector.same_time %></span>
        <% } %>
      </span>
    <% }) %>
  </div>
  <a href class="date-select-link --below-slots" data-behaviour="date-select" data-department-id="<%= address.departmentId %>" data-analytics-element="booking-reselect-more-dates" data-analytics-interaction="click"><%= I18n.suggestion_selector.see_more_dates %></a>
<% } else if (addressGroups.length) { %>
  <% addressGroups.forEach(function(group){ %>
    <div class="sp-address-card-container">
      <% if (showMessage) { %>
        <% var preamble = I18n.address_card_preamble[selectedProviderOption + '_provider'][addressGroups.length > 1 ? 'multiple_locations' : 'single_location'][group.isDesiredDepartmentId ? 'desired_location' : 'other_location'] %>
        <% if (preamble) { %>
          <div class="sp-address-card-preamble">
            <%= preamble.replaceAll('%{original_provider_name}', desiredProvider.name) %>
          </div>
        <% } %>
      <% } %>
      <div class="sp-address-card">
        <div class="sp-address-card__content">
          <div class="sp-address-card__details">
            <% var address = group.address %>
            <div class="name sp-address-card__title"><%= address.displayName %></div>
            <% if (!address.virtual) { %>
              <div class="address">
                <%= address.streetAddress %> <br />
                <%= address.city %>, <%= address.state %> <%= address.zipCode %>
                <a class="map-link" href="<%= address.mapUrl %>" target="_blank"><%= I18n.suggestion_selector.show_in_google_maps %></a>
              </div>
            <% } %>
          </div>
          <% if (!address.virtual) { %>
            <div class="sp-address-card__map" data-behaviour="sp-address-card-map-container" data-address="<%- JSON.stringify(address) %>"></div>
          <% } %>
        </div>
        <div class="sp-address-card__actions">
          <label class="field-label" data-behaviour="date-select" data-department-id="<%= address.departmentId %>" data-analytics-element="booking-reselect-more-dates" data-analytics-interaction="click">
            <span class="selected-date"><%= Sparkle.Utilities.appointmentDate(moment.parseZone(group.date), AppointmentBooking.config.slot_show_year, "dddd, MMMM D", "dddd, MMMM D, YYYY") %></span>
            <a href class="date-select-link"><%= I18n.suggestion_selector.see_more_dates %></a>
          </label>
          <div class="slot-stacks">
            <% group.slotStacks.forEach(function(stack){ %>
              <span class="slot-stack<% if (stack.containsSelectedSlot) { %> slot-stack--selected<% } %><% if (stack.slots.length > 1) { %> slot-stack--many-slots<% } else { %> slot-stack--one-slot<% } %><% if (stack.desiredTimeSlot) { %> --desired-time-slot<% } %>" data-slot-start-time="<%= stack.startTime %>">
                <span class="time"><%= moment.parseZone(stack.startTime).format(I18n.moment_time_format) %></span>
                <span class="text" title="<%= stack.text %>"><%= stack.text %></span>
                <% if (stack.desiredTimeSlot) { %>
                  <span class="button-caption"><%= I18n.suggestion_selector.same_time %></span>
                <% } %>
              </span>
            <% }) %>
          </div>
          <a href class="date-select-link --below-slots" data-behaviour="date-select" data-department-id="<%= address.departmentId %>" data-analytics-element="booking-reselect-more-dates" data-analytics-interaction="click"><%= I18n.suggestion_selector.see_more_dates %></a>
        </div>
      </div>
    </div>
  <% }) %>
<% } else { %>
  <%= I18n.suggestion_selector.no_slots_for_date %>
<% } %>
